import { render, staticRenderFns } from "./BcModalEmail.vue?vue&type=template&id=e8d410ca"
import script from "./BcModalEmail.vue?vue&type=script&lang=js"
export * from "./BcModalEmail.vue?vue&type=script&lang=js"
import style0 from "./BcModalEmail.vue?vue&type=style&index=0&id=e8d410ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports